import React from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { StatCard } from "../AdminUi";
import { inr } from "../pricing/PricingUi";

const n = (v) => Number(v || 0).toLocaleString("en-IN");

export const CreditTracker = ({ d }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="credit-tracker">
    <StatCard label="Credits sold" value={n(d.sold.credits)} sub={`${n(d.sold.online.credits)} online · ${n(d.sold.manual.credits)} added by you`} testid="tracker-credits-sold" />
    <StatCard label="₹ received" value={inr(d.sold.revenue_inr)} accent="text-emerald-600" sub={`${inr(d.sold.online.revenue_inr)} online · ${inr(d.sold.manual.revenue_inr)} direct`} testid="tracker-inr-received" />
    <StatCard label="Credits used" value={n(d.used.total)} sub={`${n(d.used.builds)} builds · ${n(d.used.domains)} domains`} testid="tracker-credits-used" />
    <StatCard label="Left in wallets" value={n(d.wallets.total)} sub={`${n(d.wallets.paid)} paid · ${n(d.wallets.free)} free · ${n(d.wallets.users)} users`} testid="tracker-wallets-left" />
  </div>
);

const Row = ({ label, value, testid, strong }) => (
  <div className="flex items-center justify-between py-2 border-b border-slate-100 last:border-0 text-sm" data-testid={testid}>
    <span className="text-slate-500">{label}</span><span className={`font-mono ${strong ? "font-semibold text-slate-900" : "text-slate-700"}`}>{value}</span>
  </div>
);

export const EmergentBalance = ({ e, right }) => {
  const short = e.needed > 0;
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 sm:p-6" data-testid="emergent-balance">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div><h2 className="text-lg font-semibold text-slate-900">Your Emergent balance</h2>
          <p className="text-sm text-slate-500">Estimated from the top-ups you record and the credits your merchants have used.</p></div>
        {right}
      </div>
      <Row label="Credits you topped up" value={`${n(e.topup_credits)} (${inr(e.topup_inr)})`} testid="emergent-topped-up" />
      <Row label="Used by merchants" value={`${n(e.used_credits)} (≈ ${inr(e.est_cost_inr)})`} testid="emergent-used" />
      <Row label="Estimated left" value={n(e.est_left)} strong testid="emergent-left" />
      <div className={`mt-4 flex items-start gap-2 rounded-xl p-3 text-sm ${short ? "bg-amber-50 text-amber-800" : "bg-emerald-50 text-emerald-800"}`} data-testid="emergent-needed">
        {short ? <AlertTriangle size={16} className="mt-0.5 shrink-0" /> : <CheckCircle2 size={16} className="mt-0.5 shrink-0" />}
        {short ? <span>Merchants hold more credits than you have left. Top up about <b>{n(e.needed)}</b> more Emergent credits to cover them.</span>
          : <span>You have enough Emergent balance to cover every credit your merchants hold.</span>}
      </div>
    </section>
  );
};
